import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import cn from 'classnames';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import { EditorContext } from '../../../Editor/Context';
import { TOOLTIP_HOVER_DELAY } from '../../../../constants';
import s from './EditorIconButton.scss';
const EditorIconButton = (_param)=>{
    var { featureId, isActive } = _param, props = _object_without_properties(_param, [
        "featureId",
        "isActive"
    ]);
    const micro_muro = useFlag('micro_muro');
    const { ref: editor } = useContext(EditorContext);
    return /*#__PURE__*/ React.createElement(IconButton, _object_spread({
        className: cn(s['root'], micro_muro && s['micro_muro'], isActive && s['is-active']),
        biData: BiData({
            evid: 193,
            view: BiContextProvidedValue,
            component: BiContextProvidedValue,
            itemid: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            preset: (editor === null || editor === void 0 ? void 0 : editor.storage['da-presetId']) || 'unknown',
            feature: featureId
        }),
        size: "large",
        tooltipHoverDelay: TOOLTIP_HOVER_DELAY
    }, props));
};
EditorIconButton.displayName = 'EditorIconButton';
export default EditorIconButton;

//# sourceMappingURL=EditorIconButton.js.map